import React from "react";
import { vibesColors as colors } from "../../theme/vibesColors";

/**
 * @param {"full" | "compact"} variant — compact = sidebar Location card
 */
export default function ClubInfoCard({
  title,
  address,
  logoUrl,
  variant = "full",
}) {
  if (variant === "compact") {
    return (
      <section
        className="club-sidebar-card club-info-card--compact"
        aria-labelledby="club-location-heading"
      >
        <h2 id="club-location-heading" className="club-sidebar-card__title">
          Location
        </h2>
        <div className="club-sidebar-card__body">
          {address ? (
            <p
              className="mb-0 flex-grow-1"
              style={{
                color: colors.white,
                fontSize: "1rem",
                lineHeight: 1.55,
              }}
            >
              <span style={{ color: "#e84855" }} aria-hidden>
                📍
              </span>{" "}
              {address}
            </p>
          ) : (
            <p className="mb-0" style={{ color: colors.textColor }}>
              Address not available.
            </p>
          )}
        </div>
      </section>
    );
  }

  return (
    <section
      className="club-info-card rounded-4 p-4"
      style={{
        background: colors.cardBackground,
        border: `1px solid ${colors.violate}66`,
        display: "flex",
        gap: 16,
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          overflow: "hidden",
          flexShrink: 0,
          background: "#111",
          border: `2px solid ${colors.violate}88`,
          backgroundImage: logoUrl ? `url(${logoUrl})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div style={{ minWidth: 0 }}>
        <h2
          style={{
            margin: "0 0 8px",
            fontSize: "1.25rem",
            fontWeight: 800,
            color: colors.white,
          }}
        >
          {title}
        </h2>
        {address ? (
          <p
            style={{
              margin: 0,
              color: colors.white,
              fontSize: "0.92rem",
              lineHeight: 1.4,
            }}
          >
            <span style={{ color: colors.violate }}>📍</span> {address}
          </p>
        ) : null}
      </div>
    </section>
  );
}
